/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Popup as SemanticUIPopup } from 'semantic-ui-react';

import ProtocolEditStep from './ProtocolEditStep';
import DeleteStep from '../../DeleteStep';
import { EditIcon, TrashIcon } from '../../../assets/icons';

import styles from './ActionsPopup.module.scss';

const ActionsStep = React.memo(({ protocol, onUpdate, onDelete }) => {
  const [t] = useTranslation();

  const [open, setOpen] = useState(false);

  const handleChannelUpdate = useCallback(
    (newData) => {
      onUpdate({
        id: protocol.id,
        name: newData.name,
        protocol: newData.protocol,
      });
    },
    [onUpdate],
  );

  const handleDelete = useCallback(() => {
    onDelete({
      id: protocol.id,
    });
  }, [onDelete]);

  const handleEditClosePopup = () => {
    setOpen(false);
  };

  const handleEditOpenPopup = () => {
    setOpen(true);
  };

  return (
    <>
      <Button className={styles.button_edit} onClick={handleEditOpenPopup}>
        <EditIcon className={styles.menuIcon} />
      </Button>
      <Modal closeIcon size="tiny" open={open} onClose={handleEditClosePopup}>
        <ProtocolEditStep
          defaultValue={protocol}
          onUpdate={handleChannelUpdate}
          onClose={handleEditClosePopup}
          onOpen={handleEditOpenPopup}
        />
      </Modal>
      <SemanticUIPopup
        position="bottom center"
        trigger={
          <Button className={styles.buttonDelete} onClick={handleEditClosePopup}>
            <TrashIcon className={styles.menuIcon} />
          </Button>
        }
        content={
          <DeleteStep
            title={t('common.deleteProtocol', {
              context: 'title',
            })}
            content={t('common.areYouSureYouWantToDeleteThisProtocol')}
            buttonContent={t('action.deleteProtocol')}
            onConfirm={handleDelete}
          />
        }
        on="click"
        hideOnScroll
      />
    </>
  );
});

ActionsStep.propTypes = {
  protocol: PropTypes.objectOf(PropTypes.any).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ActionsStep;
